import React, { useContext } from 'react';
import { Popover, Box, Button } from '@mui/material';
import { styled } from '@mui/system';
import { LanguageContext } from '../../context/LanguageContext';
import ParagraphText from '../ParagraphText';
import UBButton from '../UBButton';
import style from './styles.module.css';

const CustomPopover = styled('div')(({ theme }) => ({
    position: 'relative',
    backgroundColor: '#24272F',
    padding: '13px',
    maxWidth: '259px',
    borderRadius: '6px',
    '&::before': {
        content: '""',
        position: 'absolute',
        width: '328px',
        top: -8,
        right: '154px',
        width: 0,
        height: 0,
        borderLeft: '8px solid transparent',
        borderRight: '8px solid transparent',
        borderBottom: `8px solid #24272F`,
    },
}));

const AppAlert = ({
    open,
    anchorEl,
    onClose,
    onConfirm,
    onCancel,
    title = '',
    message = ''
}) => {
    const [I18n] = useContext(LanguageContext);

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            PaperProps={{
                sx: {
                    backgroundColor: 'transparent',
                    color: '#fff',
                    padding: '8px 0px',
                    borderRadius: 2,
                    boxShadow: 'none',
                    marginTop: 2,
                    marginRight: 2,
                    width: '259px',
                }
            }}
        >
            <CustomPopover className={style.appAlertDev}>
                <Box mb={1}>
                    <ParagraphText className={'fontSize14 fontWeight500'}>{title}</ParagraphText>
                </Box>
                <ParagraphText className={'fontSize12'} gutterBottom>
                    {message}
                </ParagraphText>
                <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
                    <UBButton id="app_alert_no_btn" className={style.cancelBtnStyle} title={I18n.no} onClick={onCancel} />
                    <UBButton id="app_alert_yes_btn" className={style.yesBtnStyle} title={`${I18n.yes}, ${I18n.update}`} onClick={onConfirm} />
                </Box>
            </CustomPopover>
        </Popover>
    );
};

export default AppAlert;
